import $ from "jquery";

let Noun_User;

Noun_User = (() => {
	function Noun_User() {
		return $("#user-config").data("user-object");
	}

	return Noun_User;
})();

export default Noun_User();
